/*
IMPORTANT - This enum translates to the SalesVolumeDisplayType in the core library for the back-end's use!
 */
export enum SalesVolumeDisplayType {
  ANNUAL = 'ANNUAL',
  WEEKLY = 'WEEKLY'
}
